import { useState } from "react";

import EditarCluster from '../../components/EditarCluster/EditarCluster';
import NotifierPopup from '../../components/NotifierPopup/NotifierPopup';

export default function EditarClusterAdm() {
    //Notifier
    const [ notify, setNotify ] = useState({
        isActive: false,
        isSuccessful: undefined,
        message: undefined
    });

    return <>
        {notify.isActive && 
            <NotifierPopup 
                notify={notify}
                setNotify={setNotify}
            />
        }
        
        <EditarCluster setNotifier = {(isSuccess, message) => setNotify({
                isActive: true,
                isSuccessful: isSuccess,
                message: message
            })}/>
        
    </>
}